import { AfterViewInit, Component, inject } from '@angular/core';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router, RouterOutlet } from '@angular/router';
import { LoaderService } from './loader/loader.service';
import { AuthService } from './shared/auth/auth.service';
import { SessionService } from './shared/auth/session.service';
import { NavigationService } from './shared/auth/navigation.service';
import { BreadcrumbService } from './shared/breadcrumb.service';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { LoaderComponent } from './loader/loader.component';
import { DialogManagerService } from './shared/dialog-manager.service';
import { FloatingDialogControlsService } from './shared/floating-dialog-controls.service';


@Component({
  selector: 'app-root',
  imports: [RouterOutlet, MatIconModule, MatButtonModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements AfterViewInit {
  title = 'elikita2';

  router = inject(Router);
  loaderService = inject(LoaderService);
  breadCrumbService = inject(BreadcrumbService);
  sessionService = inject(SessionService); // ADD THIS
  navigationService = inject(NavigationService); // ADD THIS
  dialogManager = inject(DialogManagerService);
  floatingControls = inject(FloatingDialogControlsService);
  isDark = false;

  constructor(private auth: AuthService) {
    const saved = localStorage.getItem('color-scheme');
    if (saved) {
      this.isDark = saved === 'dark';
      this.applyTheme();
    }
  }

  toggleTheme() {
    this.isDark = !this.isDark;
    localStorage.setItem('color-scheme', this.isDark ? 'dark' : 'light');
    this.applyTheme();
  }

  applyTheme() {
    document.documentElement.setAttribute('color-scheme', this.isDark ? 'dark' : 'light');
  }

  ngOnInit() {
    // Wait for router to be ready before checking
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // Only redirect if user lands on root or launch pages
        const session = this.sessionService.getSession();

        if (session?.isLoggedIn &&
          (event.url === '/' || event.url === '/launch' || event.url === '/home')) {
          const role = session.role;
          const defaultRoute = this.navigationService.getDefaultRouteForRole(role);
          console.log(`🚀 Redirecting logged-in ${role} from ${event.url} to ${defaultRoute}`);
          this.router.navigate([defaultRoute]);
        }
      }



    });

    // Ensure auth user has practitioner type and userId if needed
    const u = this.auth.user.getValue();
    if (u) {
      const randomId = crypto.randomUUID ? crypto.randomUUID() : Math.floor(Math.random() * 1e12).toString();

      // Only update if fields are missing
      if (!u.accountType || !u.userType || !u.userId) {
        this.auth.user.next({
          ...u,
          accountType: u.accountType || u.role,  // ✅ Use accountType if available
          userType: u.accountType || u.userType || u.role?.toLowerCase() || 'practitioner',  // Lowercase for capacityObject
          userId: u.userId || u.id || randomId
        });
      }
    }
  }

  closeTopDialog() {
    this.dialogManager.closeTopDialog();
  }

  ngAfterViewInit(): void {
    this.floatingControls.init();
  }
}